module.exports = __webpack_public_path__ + "img/2b870b40-a436-42b9-980f-538e303cdfce.651a3fa3.webp";